export default __webpack_public_path__ + "static/media/addNote.e7501e57.svg";